export class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector(
            "[js-predictive-search]",
        );

        this.input.addEventListener(
            "input",
            theme.utils
                .debounce((event) => {
                    this.onChange(event);
                }, 300)
                .bind(this),
        );
    }

    connectedCallback() {
        this.drawer = document.querySelector("#PredictiveSearchDrawer");
        this.headerNav = document.querySelector("[js-header-nav]");
        this.clearSearchBtn = this.querySelector("[js-clear-search]");

        this.setListeners();
    }

    setListeners = () => {
        this.drawer.addEventListener("open", () => {
            this.input.focus();
            if (!this.headerNav.classList.contains("active")) {
                this.headerNav.classList.add("active");
            }
        });

        this.drawer.addEventListener("close", () => {
            var lastScrollTop = 0;
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (st === lastScrollTop) {
                this.headerNav.classList.remove("active");
            }
        });

        this.clearSearchBtn.addEventListener("click", this.clearSearch);
    };

    clearSearch = (evt) => {
        evt.preventDefault();
        this.input.value = "";
        this.onChange();
    };

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        fetch(
            `${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product,collection,article,page&resources[limit]=4&section_id=predictive-search`,
        )
            .then((response) => {
                if (!response.ok) {
                    const error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser()
                    .parseFromString(text, "text/html")
                    .querySelector(
                        "#shopify-section-predictive-search",
                    ).innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.predictiveSearchResults.style.display = "block";
    }

    close() {
        this.predictiveSearchResults.style.display = "none";
    }
}
